import React from 'react';
const SliderSection2 = (props) => {
    return (
            <div className="fullwidth slider-section2 text-center" id="SliderSection2">
                <div className="container-fluid">
                    <div id="slider2" className="owl-carousel owl-theme">
                        <div className="item"> <img alt="bw1" src="/img/bw1.png" /></div>
                        <div className="item"> <img alt="bw3"  src="/img/bw3.png" /></div>
                        <div className="item"> <img alt="bw5"  src="/img/bw5.png" /></div>
                        <div className="item"> <img alt="bw6"  src="/img/bw6.png" /></div>
                    </div>
                </div>
            </div>
            )

}


export default SliderSection2


// WEBPACK FOOTER //
// ./src/components/Home/Slider2-Section.js